// Full-screen "rotate to portrait" overlay shown when:
//   - the device is in landscape, AND
//   - the viewport is mobile-sized (max-width 900px), AND
//   - the Coach view is in immersive mode (workout running/paused).
//
// Acts as a fallback for environments where screen.orientation.lock('portrait')
// isn't supported (iOS Safari most notably).

import React, { useContext, useEffect, useState } from "react";
import { RotateCcw } from "lucide-react";
import { AppStateContext } from "../../contexts/WorkoutContext";
import useWorkoutSettings from "../../hooks/useWorkoutSettings";

const QUERY = "(orientation: landscape) and (max-width: 900px)";

const LandscapeOverlay = () => {
  const { isImmersive } = useContext(AppStateContext);
  // Only when the Coach is set to stay upright (#149).
  const [ws] = useWorkoutSettings();
  const [matches, setMatches] = useState(() => {
    if (typeof window === "undefined" || !window.matchMedia) return false;
    return window.matchMedia(QUERY).matches;
  });

  useEffect(() => {
    if (typeof window === "undefined" || !window.matchMedia) return undefined;
    const mql = window.matchMedia(QUERY);
    const handler = (e) => setMatches(e.matches);
    mql.addEventListener("change", handler);
    return () => mql.removeEventListener("change", handler);
  }, []);

  if (!isImmersive || !matches || ws.coachOrientation !== "portrait") return null;

  return (
    <div className="fixed inset-0 z-[100] flex flex-col items-center justify-center gap-4 bg-black/95 text-center text-white p-6">
      <RotateCcw className="h-12 w-12 text-white/70 animate-pulse" />
      <p className="text-lg font-semibold">Please rotate to portrait</p>
      <p className="text-sm text-white/60 max-w-xs">
        Coach view is portrait-only during workouts.
      </p>
    </div>
  );
};

export default LandscapeOverlay;
